/**
* Logos Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logos Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'logos-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.logos-slider' ).each( function() {
        $( this ).find( '.slider' ).slick( {
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          centerMode: true,
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: true,
          initialSlide: 1,
          arrows: false,
          buttons: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                centerMode: true,
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                centerMode: true,
                slidesToShow: 1,
              },
            },
          ],
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logos-slider', COMPONENT );
} )( app );
